import { render, staticRenderFns } from "./ActionList.vue?vue&type=template&id=72052f3e&"
import script from "./ActionList.vue?vue&type=script&lang=js&"
export * from "./ActionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports